import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ExpiredNotification from './notifications/ExpiredNotification';
import { isExpiredAccountState } from '../../redux/fe-data/selectors';
import styles from '../App/styles.module.css';

function CallToActions(props) {
  const { isExpiredAccount } = props;
  const getNotification = () => (isExpiredAccount
    ? (
      <div className={styles.reactNurtureBar}>
        <ExpiredNotification />
      </div>
    ) : null);

  return getNotification();
}

CallToActions.propTypes = {
  isExpiredAccount: PropTypes.bool,
};

CallToActions.defaultProps = {
  isExpiredAccount: false,
};

const mapStateToProps = state => ({
  isExpiredAccount: isExpiredAccountState(state),
});

export default connect(mapStateToProps)(CallToActions);
